import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Solutions from './pages/Solutions';
import Contact from './pages/Contact';
import Team from './pages/Team';
import ResearchArticle from './components/research/ResearchArticle';
import ResearchLinksMessages from './components/research/ResearchLinksMessages';

export default function App() {
  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "NOVIONIX Labs",
    "url": "https://novionix.ai",
    "logo": "https://novionix.ai/logo.png",
    "sameAs": [
      "https://www.linkedin.com/company/novionix",
      "https://github.com/novionix",
      "https://twitter.com/NOVIONIXLabs"
    ],
    "description": "NOVIONIX Labs builds a new kind of intelligence—our Heuristic Inference Engine adapts in real time across sports, healthcare, and beyond."
  };

  const siteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "url": "https://novionix.ai",
    "name": "NOVIONIX Labs",
    "publisher": { "@id": "https://novionix.ai/#organization" },
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://novionix.ai/search?q={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  };

  return (
    <div className="app-container">
      <Helmet>
        {/* Basic */}
        <meta charSet="utf-8" />
        <title>NOVIONIX Labs – A New Kind of Intelligence</title>
        <meta name="description" content="We engineer real-time, adaptive AI systems—Heuristic Inference Engines that move, adapt, and think."/>
        <meta name="keywords" content="adaptive AI, heuristic inference, real-time intelligence, HIE engine, NOVIONIX Labs"/>
        <meta name="robots" content="index,follow"/>
        <meta name="viewport" content="width=device-width,initial-scale=1"/>

        {/* Canonical & Discovery */}
        <link rel="canonical" href="https://novionix.ai"/>
        <link rel="alternate" type="application/rss+xml" title="NOVIONIX Labs RSS" href="/rss.xml"/>
        <link rel="sitemap" type="application/xml" title="Sitemap" href="/sitemap.xml"/>

        {/* OpenGraph */}
        <meta property="og:locale" content="en_US"/>
        <meta property="og:type" content="website"/>
        <meta property="og:title" content="NOVIONIX Labs – A New Kind of Intelligence"/>
        <meta property="og:description" content="Heuristic Inference Engines that adapt in real time across sports, healthcare, and beyond."/>
        <meta property="og:url" content="https://novionix.ai"/>
        <meta property="og:image" content="https://novionix.ai/logo.png"/>

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image"/>
        <meta name="twitter:site" content="@NOVIONIXLabs"/>
        <meta name="twitter:title" content="NOVIONIX Labs – A New Kind of Intelligence"/>
        <meta name="twitter:description" content="Heuristic Inference Engines that adapt in real time."/>
        <meta name="twitter:image" content="https://novionix.ai/logo.png"/>

        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            ...orgSchema,
            "@id": "https://novionix.ai/#organization"
          }, null, 2)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(siteSchema, null, 2)}
        </script>
      </Helmet>

      <Header />

      <main className="app-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/team" element={<Team />} />
          <Route path="/research" element={<ResearchLinksMessages />} />
          <Route path="/research/:slug" element={<ResearchArticle />} />
        </Routes>
      </main>

      <Footer />
    </div>
  );
}
